import { lazy } from 'react';

export const ErrorPage = lazy(() => import('../pages/ErrorPage'));
export const PasswordResetPage = lazy(
  () => import('../pages/PasswordResetPage'),
);
export const DesktopAuthPage = lazy(() => import('../pages/DesktopAuthPage'));
export const FormsPage = lazy(() => import('../pages/FormsPage'));
export const AnalyticsPage = lazy(() => import('../pages/AnalyticsPage'));
export const LedgerPage = lazy(() => import('../pages/LedgerPage'));
export const SettingsPage = lazy(() => import('../pages/SettingsPage'));
export const APIsPage = lazy(() => import('../pages/APIsPage'));
export const ArchivePage = lazy(() => import('../pages/ArchivePage'));
export const ErrorTestingPage = lazy(() => import('../pages/ErrorTestingPage'));
export const ValtioDebugPage = lazy(() => import('../pages/ValtioDebugPage'));
export const IntakePage = lazy(() => import('../pages/IntakePage'));
export const IntakeSchedulePage = lazy(() => import('../pages/IntakeSchedulePage'));
export const IntakePricebookPage = lazy(() => import('../pages/IntakePricebookPage'));
